import {
  Admin,
  CustomRoutes,
  Resource,
  localStorageStore,
  useStore,
  StoreContextProvider,
} from 'react-admin';
import { Route } from 'react-router';

import authProvider from './authProvider';
import categories from './categories';
import { Dashboard } from './dashboard';
import { Layout, Login } from './layout';
import products from './products';
import { themes, ThemeName } from './themes/themes';

import SubCategoryList from './sub-categories/SubCategoryList';
import SubCategoryEdit from './sub-categories/SubCategoryEdit';
import CarouselList from './carousel/CarouselList';
import CarouselEdit from './carousel/CarouselEdit';
import BroadcastList from './broadcast/BroadcastList';
import BroadcastEdit from './broadcast/BroadcastEdit';
import BroadcastAdd from './broadcast/BroadcastAdd';
import Settings from './Settings';
import { ContentTree } from './content/ContentTree';
import History from './History';
import Instructions from './Instructions';
import CarouselStructure from './carousel/CarouselStructure';
import Managers from './shop/Manager';

const store = localStorageStore(undefined, 'ECommerce');

const App = () => {
  const [themeName] = useStore<ThemeName>('themeName', 'Стандарт');
  const singleTheme = themes.find((theme) => theme.name === themeName)?.single;
  const lightTheme = themes.find((theme) => theme.name === themeName)?.light;
  const darkTheme = themes.find((theme) => theme.name === themeName)?.dark;
  return (
    <Admin
      title="VATSAK Панель"
      store={store}
      authProvider={authProvider}
      dashboard={Dashboard}
      loginPage={Login}
      layout={Layout}
      disableTelemetry
      theme={singleTheme}
      lightTheme={lightTheme}
      darkTheme={darkTheme}
      defaultTheme="light"
      requireAuth
    >
      <CustomRoutes>
        <Route path="/sub-categories" element={<SubCategoryList />} />
        <Route path="/sub-categories/:id" element={<SubCategoryEdit />} />
        <Route path="/carousele" element={<CarouselList />} />
        <Route path="/carousele/new" element={<CarouselCreate />} />
        <Route path="/carousel/:id" element={<CarouselEdit />} />
        <Route path="/broadcasts" element={<BroadcastList />} />
        <Route path="/broadcast/:id" element={<BroadcastEdit />} />
        <Route path="/broadcasts/new" element={<BroadcastAdd />} />
        <Route path="/media" element={<MediaList />} />
        <Route path="/media/new" element={<MediaAdd />} />
        <Route path="/media/:id" element={<MediaEdit />} />
        <Route path="/products/new" element={<ProductAdd />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/content" element={<ContentTree />} />
        <Route path="/history" element={<History />} />
        <Route path="/structure" element={<CarouselStructure />} />
        <Route path="/viber-settings" element={<ViberSettings />} />
        <Route path="/instructions" element={<Instructions />} />
        <Route path="/managers" element={<Managers />} />
        <Route path="/managers/edit/:id" element={<ManagerEdit />} />
        <Route path="/managers/new" element={<ManagerAdd />} />
        <Route path="/shops" element={<Shops />} />
        <Route path="/shops/new" element={<ShopsNew />} />
        <Route path="/shops/edit/:id" element={<ShopsEdit />} />
        <Route path="/modules-products" element={<ModuleProducts />} />
        <Route path="/modules-orders" element={<ModuleOrders />} />
        <Route path="/modules-history" element={<ModuleHistory />} />
        <Route path="/modules-macros" element={<ModuleMacros />} />
        <Route path="/cities" element={<Cities />} />
      </CustomRoutes>
      <Resource name="products" {...products} />
      <Resource name="categories" {...categories} />
    </Admin>
  );
};

import { BrowserRouter } from 'react-router-dom';
import MediaList from './media/Media';
import MediaAdd from './media/MediaAdd';
import MediaEdit from './media/MediaEdit';
import ProductAdd from './products/ProductAdd';
import CarouselCreate from './carousel/CarouselCreate';
import ViberSettings from './ViberSettings';
import ManagerEdit from './shop/ManagerEdit';
import ManagerAdd from './shop/ManagerAdd';
import Shops from './shop/Shops';
import ShopsEdit from './shop/ShopsEdit';
import ShopsNew from './shop/ShopsNew';
import ModuleProducts from './ModuleProducts';
import ModuleOrders from './ModuleOrders';
import ModuleHistory from './ModuleHistory';
import ModuleMacros from './MacrosEditor';
import Cities from './Cities';

const AppWrapper = () => (
  <BrowserRouter>
    <StoreContextProvider value={store}>
      <App />
    </StoreContextProvider>
  </BrowserRouter>
);

export default AppWrapper;
